import { supabase } from "@/integrations/supabase/client";

const KEY = "pzm_lead_id";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Store lead_id from a lead-invitation link (utm_source=lead). Separate from UTM tracking. */
export function captureLeadId(): void {
  try {
    const p = new URLSearchParams(window.location.search);
    const id = p.get("lead_id");
    if (id && UUID.test(id) && ["lead", "nieuwsbrief_extern"].includes(p.get("utm_source") || "")) localStorage.setItem(KEY, id);
  } catch { /* ignore */ }
}

/** Mark a lead as signed up after caregiver signup (email match or stored lead id). Never throws. */
export async function markLeadSignedUp(): Promise<void> {
  try {
    const id = localStorage.getItem(KEY);
    await supabase.rpc("lead_mark_signed_up", { _lead_id: id && UUID.test(id) ? id : null });
    localStorage.removeItem(KEY);
  } catch { /* never block signup */ }
}
